const comments = [
  {
    name: '吃瓜小能手',
    avatar: '😎',
    date: '2小时前',
    content: '吃瓜网51真的是我每天必刷的网站！更新速度太快了，每次有大瓜都能在这里第一时间看到，比微博还快。而且信息整理得很清晰，不像其他平台那么杂乱。强烈安利给所有吃瓜姐妹！',
    likes: '328',
  },
  {
    name: '娱乐达人小李',
    avatar: '🤩',
    date: '5小时前',
    content: '用了大半年了，吃瓜网51网页版的体验一直很稳定。平时上班摸鱼就用电脑看，通勤路上手机也能流畅访问。最赞的是内容质量，每一条都是精挑细选的，没有那些乱七八糟的营销号文章。',
    likes: '256',
  },
  {
    name: '追剧不停歇',
    avatar: '🍿',
    date: '1天前',
    content: '从吃瓜网51官网版追了整整一年的娱乐资讯，已经成为我的信息获取习惯了。影视盘点、综艺花絮、明星动态一网打尽，分类也很人性化。希望平台越做越好，会一直支持的！',
    likes: '189',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              吃瓜群众说
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              来看看广大吃瓜群众对平台的真实评价
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-xl">
                    {comment.avatar}
                  </div>
                  <div>
                    <span className="block text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="block text-xs text-foreground-500 whitespace-nowrap">
                      {comment.date}
                    </span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-heart-line text-primary-500"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}